import { useState } from 'react';
import USERS from '../users';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');

  function handleSubmit(e) {
    e.preventDefault();
    const found = USERS.find(u => u.username === username.trim() && u.password === password);
    if (found) { onLogin(found); }
    else { setError('Usuário ou senha incorretos.'); }
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-icon">
          <svg viewBox="0 0 22 22">
            <path d="M4 15 L11 6 L18 15"/><path d="M7.5 12 L14.5 12"/>
          </svg>
        </div>
        <h1>Revista Ordem Pública</h1>
        <p>Acesse com suas credenciais</p>

        <form onSubmit={handleSubmit}>
          <div className="field">
            <label htmlFor="user">Usuário</label>
            <input id="user" type="text" placeholder="seu usuário" autoComplete="username"
              value={username} onChange={e => { setUsername(e.target.value); setError(''); }} />
          </div>
          <div className="field">
            <label htmlFor="pass">Senha</label>
            <input id="pass" type="password" placeholder="••••••••" autoComplete="current-password"
              value={password} onChange={e => { setPassword(e.target.value); setError(''); }} />
          </div>
          <button className="btn-primary" type="submit">Entrar</button>
          {error && <p className="error-msg">{error}</p>}
        </form>
      </div>
    </div>
  );
}
